import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagNZ = function FlagNZ() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
    fill: "#0052B4",
    d: "M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25C0 25.006 25 .003 25 0c13.807 0 25 11.193 25 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M24.932 24.999H25v-.067l-.067.067Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M25 13.043V0h-.004C11.19.002 0 11.194 0 25h13.043v-7.345L20.389 25h4.545l.067-.067V20.39l-7.345-7.345H25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D80027",
    d: "M12.649 3.262a25.12 25.12 0 0 0-9.387 9.387V25h6.521V9.784h15.218V3.262H12.649Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D80027",
    d: "m25.001 21.927-8.882-8.882h-3.074L25 25.001v-3.074ZM43.294 18.55l.54 1.661h1.746l-1.413 1.027.54 1.66-1.413-1.026-1.413 1.026.54-1.66-1.413-1.027h1.746l.54-1.66ZM37.052 30.508l.81 2.491h2.62l-2.12 1.54.81 2.491-2.12-1.54-2.119 1.54.81-2.491-2.12-1.54h2.62l.81-2.49ZM37.289 10.942l.675 2.076h2.182l-1.766 1.283.675 2.076-1.766-1.283-1.766 1.283.675-2.076-1.766-1.283h2.182l.675-2.076ZM31.282 18.479l.809 2.49h2.62l-2.12 1.54.81 2.491-2.12-1.54L29.164 25l.809-2.49-2.12-1.54h2.62l.81-2.491Z"
  }));
};
FlagNZ.displayName = 'FlagNZ';
export default withFlagWrapper(FlagNZ);
//# sourceMappingURL=index.js.map